export const TARGET_LEVELS = ["Corporate", "Business Unit", "Site"] as const;
export type TargetLevel = (typeof TARGET_LEVELS)[number];

/** value matches API scope (scope1, scope2, scope1&2) */
export const EMISSIONS_SCOPES = [
  { label: "Scope 1", value: "scope1" },
  { label: "Scope 2", value: "scope2" },
  { label: "Scope 1 and 2", value: "scope12" },
] as const;

export const TARGET_TYPES = {
  PERCENT_REDUCTION: "% Reduction",
  ABSOLUTE_TCO2E: "Absolute tCO₂e",
} as const;
export type TargetType = (typeof TARGET_TYPES)[keyof typeof TARGET_TYPES];

export const ANNUAL_PATH_OPTIONS = {
  EVEN: "Even reduction each year",
  CUSTOM: "Custom annual values",
} as const;
export type AnnualPathOption = (typeof ANNUAL_PATH_OPTIONS)[keyof typeof ANNUAL_PATH_OPTIONS];

export interface TargetFormData {
  targetLevel: TargetLevel | "";
  entity: string;
  targetType: TargetType;
  emissionsScope: string;
  baselineYear: string | null;
  targetYear: string | null;
  targetValue: string;
  annualTargetPath: AnnualPathOption;
  customAnnualValues: Record<string, string>;
  notes: string;
}

export interface EditTargetData {
  id: number;
  targetLevel: TargetLevel;
  entity: string;
  targetType: TargetType;
  emissionsScope: string;
  baselineYear: number;
  targetYear: number;
  targetValue: number;
  annualTargetPath: AnnualPathOption;
  customAnnualValues?: Record<number, number>;
  notes?: string;
}
